<template>
  <div id="page" class="container-fluid">
    <div class="row header mx-4 my-4">
      <div class="col my-3">
        <h1>Estimate Fees
          <b-button class="ml-3" variant="outline-orange" @click="addEstimateFee()">
            <font-awesome-icon class="orange" icon="plus"/>
            New
          </b-button></h1>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row data-table-header">
        <div class="col-2">Description</div>
        <div class="col-2">Amount</div>
        <div class="col-2">Fee Type</div>
        <div class="col-2">Covered Item</div>
        <div class="col-1">Default</div>
        <div class="col-3"></div>
      </div>
      <div v-for="estimateFee in estimateFees" :key="estimateFee.organizationEstimateFeeId" class="row data-table-row" >
        <div class="column col-2">{{ estimateFee.description }}</div>
        <div class="column col-2">{{ formatNumberOrPercent(estimateFee) }}</div>
        <div class="column col-2">{{ estimateFeeType(estimateFee.feeType) }}</div>
        <div class="column col-2">{{ itemIsCovered(estimateFee.coveredItem) }}</div>
        <div class="column col-1">{{ isDefault(estimateFee.appliedByDefault) }}</div>
        <div class="col-3 text-right">
          <button title="Edit" @click.prevent="editEstimateFee(estimateFee)" type="button" class="btn btn-outline-orange m-1 wide-button">
            <font-awesome-icon class="orange mr-2" :icon="['far', 'edit']"/>Edit
          </button>
          <button title="Delete" @click.prevent="deleteEstimateFee(estimateFee)" type="button" class="btn btn-outline-orange m-1 wide-button">
            <font-awesome-icon class="orange mr-2" :icon="['far', 'trash-alt']"/>Delete
          </button>
        </div>
      </div>
    </div>
    <estimate-fee-modal :edit-estimate-fee="editingEstimateFee" @updated="estimateFeesUpdated" :visible="showingEstimateFeeModal" @update:visible="visible => showingEstimateFeeModal = visible"></estimate-fee-modal>
  </div>
</template>
<script>
  import api from '@/services/api'
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import EstimateFeeModal from '@/components/EstimateFeeModal.vue'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'EstimateFees',
    components: { EstimateFeeModal },
    mixins: [ErrorsMixin, AnalyticsMixin],
    data () {
      return {
        estimateFees: [],
        estimateFeeId: 0,
        editingEstimateFee: {},
        showingEstimateFeeModal: false
      }
    },
    methods: {
      loadData () {
        api.get('Dashboard/EstimateFees').then(response => {
          this.trackEvent('EstimateFee', 'Load', 'ResponseTime', response.config.requestDuration)
          this.estimateFees = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('EstimateFee', 'LoadError', error.message)
            this.$log.error('Error attempting to load estimate fees: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        })
      },

      deleteEstimateFee (estimateFee) {
        api.delete('Dashboard/EstimateFee/' + estimateFee.organizationEstimateFeeId).then(() => {
          this.loadData()
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('EstimateFee', 'DeleteError', error.message)
            this.$log.error('Error attempting to delete estimate fees: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        })
      },

      formatNumberOrPercent (estimateFee) {
        if (estimateFee && estimateFee.feeType === 'FlatAmount') {
          return '$' + estimateFee.amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        } else if (estimateFee.amount && (estimateFee.feeType === 'PercentageOfCodes' || 'PercentageOfTotal')) {
          return estimateFee.amount * 100 + '%'
        }

      },
      estimateFeeType (type) {
        if (type === 'FlatAmount') {
          return 'Flat Amount'
        }
        if (type === 'PercentageOfCodes') {
          return 'Percentage Of Codes'
        }
        if (type === 'PercentageOfTotal') {
          return 'Percentage Of Total'
        }
      },

      itemIsCovered (covered) {
        if (covered === true) {
          return 'Yes'
        }
        if (covered === false) {
          return 'No'
        }
      },
      isDefault (appliedDefault) {
        if (appliedDefault === true) {
          return 'Yes'
        }
        if (appliedDefault === false) {
          return 'No'
        }
      },
      addEstimateFee () {
        this.editingEstimateFee = {
          amount: '',
          appliedByDefault: false,
          coveredItem: false,
          description: '',
          feeType: null,
          isDeleted: false,
          shortCode: ''
        }
        this.showingEstimateFeeModal = true
      },

      editEstimateFee (estimateFee) {
        this.editingEstimateFee = estimateFee
        this.showingEstimateFeeModal = true
      },

      estimateFeesUpdated () {
        this.showingEstimateFeeModal = false
        this.loadData()
      }

    },
    created () {
      this.loadData()
    }
  }
</script>
